import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AbstractControl } from '@angular/forms';
import { LoggerService } from './../../logger/logger.service';
import { AgentService } from '../agent.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-agent-dashboard',
    templateUrl: './agent-dashboard-component.html',
    styleUrls: ['./agent-dashboard-component.css']
  })

  export class AgentDashboard implements OnInit {
    constructor(private activatedRoute: ActivatedRoute,
        private sharedService: SharedService, private dialog: MatDialog,private logger:LoggerService, private router: Router,
        private localStorageService: LocalStorageService, private agentService: AgentService) {
        this.sharedService.setHeaderTitle('agent_dashboard');

        let methodName = this.constructor.name+'.verifyToken';
        if (this.localStorageService.get('agentToken') != null) {
            this.sharedService.verifyToken({'token' : this.localStorageService.get('agentToken'), 'isAgent': true})
            .then(res => {
              let logObj = {
                method: methodName,
                request: this.localStorageService.get('agentToken'),
                response: res
              };
              this.logger.logInfo(JSON.stringify(logObj));
                if (res.status === 'success') {
                  this.sharedService.setHeaderErrorMessage('agent_dashboard', false, 'notification error', '');
                  this.sharedService.setHeaderUserLoggedIn('agent_dashboard', true, res.results[0].personal[0]);
                }else {
                  this.router.navigate(['./internal-user/sign-in']);
                }
            }, (error)=>{
              let logObj = {
                method: methodName,
                request: this.localStorageService.get('agentToken'),
                exception: error
              };
              this.logger.logError(JSON.stringify(logObj));
            }).catch((ex)=>{
              let logObj = {
                method: methodName,
                request: this.localStorageService.get('agentToken'),
                exception: ex
              };
              this.logger.logError(JSON.stringify(logObj));
            });
          }else {
            this.router.navigate(['./internal-user/sign-in']);
          }
       }


    ngOnInit(){}


    onAddServiceClick(){
      this.router.navigate(['./internal-user/service/add']);
    }

    onSyncClick(){
      this.router.navigate(['./internal-user/sync']);
    }

    onLoginClick(){
      this.router.navigate(['./internal-user/account-search']);
    }

	onSupDownload() {
		this.router.navigate(['./internal-user/sup-download']);
	}

    onSearchFlaggedEsiidClick(){
      this.router.navigate(['./internal-user/flag-search']);
    }

	onDppOverrideClick(){
      this.router.navigate(['./internal-user/dpp-override']);
    }

    onIAGClick() {
      window.open(environment.amberAdminUrl + 'dashboard', "_blank");
    }

    onCBPClick(){
      this.router.navigate(['./internal-user/chargeback-process']);
    }
  }



// WEBPACK FOOTER //
// ./src/app/agent/agent-dashboard/agent-dashboard-component.ts